import React from 'react'
import positiveroom from '../Assets/positiveroom.png'
import negativeroom from '../Assets/negativeroom.png'
import arrowlawlab from '../Assets/arrowlawlab.png'
import { useTranslation } from 'react-i18next'


const FrigoRooms = (props) => {
    const {t, i18n} = useTranslation();
    const isRTL = i18n.language === 'ar';
  return (
    <div className={`${props.motherclassName} ${props.padd}`}>

        <div className={`${props.className1} border-2 border-paragraph/30 rounded-3xl h-full `}>
            <div className={`bg-gradient-to-b from-transparent  to-secondary w-fit p-[1px] rounded-lg`}>
                <div className={`${props.className2} bg-white rounded-lg`}>
                    <img src={positiveroom} alt='positive' className={`${props.className3}  aspect-[104/81]`}/>
                </div>
            </div>
            <h1 className={`${props.className4} my-0 uppercase font-bold text-primary02 `}>{t('homepage.servicesection.stockCrads.card2.title')}</h1>
            <p className={`${props.className5}  text-paragraph text-center `}>
                {t('homepage.servicesection.stockCrads.card2.description')}
            </p>
            
        </div>
        <div className={`${props.className1} border-2 border-paragraph/30 rounded-3xl h-full `}>
            <div className={`bg-gradient-to-b from-transparent  to-secondary w-fit p-[1px] rounded-lg`}>
                <div className={`${props.className2} bg-white rounded-lg`}>
                    <img src={negativeroom} alt='positive' className={`${props.className3}  aspect-[104/81]`}/>
                </div>
            </div>
            <h1 className={`${props.className4} my-0 uppercase font-bold text-primary02 `}>{t('homepage.servicesection.stockCrads.card1.title')}</h1>
            <p className={`${props.className5}  text-paragraph text-center relative`}>
                {t('homepage.servicesection.stockCrads.card1.description')}
                <div className='absolute animate-bounce
                    -bottom-[70px] xs:-bottom-[90px] sm:-bottom-[150px]  md:-bottom-[100px] lg:-bottom-[130px] xxl:-bottom-[170px]
                    -right-[30px] xs:-right-[40px] sm:-right-[92px] xxl:-right-[150px] 
                    h-[80px] xs:h-[90px] sm:h-[150px] md:h-[120px] lg:h-[150px] xxl:h-[200px] z-50'> 
                    <img src={arrowlawlab} alt='arrow' className='h-full'/>
                 </div>
            </p>
        </div>
</div>
  )
}

export default FrigoRooms